import React, { createContext, useContext, useMemo } from 'react';
import useNotifications from '../hooks/useNotifications';
import { useAuth } from './AuthContext';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const { userId, role, getValidToken } = useAuth();
    const notificationsHook = useNotifications({
        userId,
        role,
        getValidToken,
        enabled: !!userId && !!role,
    });

    // Memoize context value to avoid unnecessary rerenders
    const contextValue = useMemo(() => notificationsHook, [notificationsHook]);

    return (
        <NotificationContext.Provider value={contextValue}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotificationContext = () => {
    const ctx = useContext(NotificationContext);
    if (!ctx) throw new Error('useNotificationContext must be used within a NotificationProvider');
    return ctx;
};